import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Crypto Redux States
import {
  CLEAR_PLACES,
  CLEAR_PLACE_KEYWORD,
  GET_BIRTH_CHART,
  GET_BIRTH_CHART_LIST,
  GET_BIRTH_CHART_PDF,
  GET_PLACES,
  GET_PLACES_API_TOKEN,
  POST_BIRTH_DETAILS_INPUT,
  SET_PLACE_KEYWORD,
  CREATE_PAYPAL_ORDER,
  APPROVE_PAYPAL_ORDER,
  REPORT_ORDER_CONFIRMATION,
} from "./actionTypes"

import {
  postBirthDetailsInputSuccess,
  postBirthDetailsInputFail,
  getBirthChartListSuccess,
  getBirthChartListFail,
  getBirthChartSuccess,
  getBirthChartFail,
  getPlacesSuccess,
  getPlacesFail,
  setPlaceKeyword,
  clearPlaceKeyword,
  clearPlaces,
  getBirthChartPDFSuccess,
  getBirthChartPDFFail,
  getPlacesAPITokenSuccess,
  getPlacesAPITokenFail,
  createPayPalOrderSuccess,
  createPayPalOrderFail,
  approvePayPalOrderSuccess,
  approvePayPalOrderFail,
  reportOrderConfirmSuccess,
  reportOrderConfirmFail,

} from "./actions"

import {
  postBirthDetails,
  getBirthChartList,
  getBirthChart,
  getPlaces,
  getBirthChartForProductAdmin,
  getBirthChartPDF,
  getPlacesAPIToken,
  createPayPalOrder,
  approvePayPalOrder,
  reportOrderConfirmatation,

} from "helpers/backend_helper"

import { isEmpty } from "lodash"

function* fetchBirthChartList({ payload }) {
  console.log("inside fetchBirthChartList saga")
  console.log("payload, jkkkkkkkk ", payload)
  try {
    const response = yield call(getBirthChartList, {
      params: {
        page: payload.page, size: payload.size,
        sortOrder: payload.sortOrder, reportCreatedDate: payload.reportCreatedDate
      }
      })
    console.log("response, ", response)
    yield put(getBirthChartListSuccess({
      userBirthChartList: response.content,
      page: response.page,
      size: response.size,
      sortOrder: payload.sortOrder,
      totalPages: response.totalPages,
      totalElements: response.totalElements,
      numberOfElements: response.numberOfElements,
    }))
  } catch (error) {
    if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
      yield put(getBirthChartListFail(error.response.data))
    } else {
      yield put(getBirthChartListFail(error.message))
    }
  }
}

function* fetchBirthChart({ chartId }) {
  try {
    let userRoles = {
      user: false,
      productAdmin: false,
    }
    if (sessionStorage.getItem("userRoles")) {
      let savedUserRoles = JSON.parse(sessionStorage.getItem("userRoles"));
      if (savedUserRoles !== undefined) {
        userRoles = savedUserRoles;
      }
    }

    let response;
    if (userRoles.user) {
      response = yield call(getBirthChart, chartId)
    } else if (userRoles.productAdmin) {
      response = yield call(getBirthChartForProductAdmin, {
        params: {
          id: chartId,
          userType: "ASTROUSER",
        }
      })
    }
    yield put(getBirthChartSuccess(response))
  } catch (error) {
    yield put(getBirthChartFail(error))
  }
}

function* fetchBirthChartPDF({ birthChartId }) {
  try {
    console.log("inside fetchBirthChartPDF saga ::::::::::::::")
    console.log(birthChartId)
    let userRoles = {
      user: false,
      productAdmin: false,
    }
    if (sessionStorage.getItem("userRoles")) {
      let savedUserRoles = JSON.parse(sessionStorage.getItem("userRoles"));
      if (savedUserRoles !== undefined) {
        userRoles = savedUserRoles;
      }
    }

    let response;
    if (userRoles.productAdmin) {
      response = yield call(getBirthChartPDF, birthChartId)
    }

    yield put(getBirthChartPDFSuccess(response))
  } catch (error) {
    yield put(getBirthChartPDFFail(error))
  }
}

function* postBirthDetailsInputSaga({ birthDetail }) {
  //console.log("birthDetail obj saga,", birthDetail)
  try {
    const response = yield call(postBirthDetails, birthDetail)
    //response.tabValue = birthDetail.tabValue
    console.log("response obj saga success,", response)
    yield put(postBirthDetailsInputSuccess(response))
  } catch (error) {
    console.log("response obj saga error,", error)
    if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
      yield put(postBirthDetailsInputFail(error.response.data))
    } else {
      yield put(postBirthDetailsInputFail(error.message))
    }
  }
}

function* getPlacesSaga({ placeInput }) {
  try {
    console.log("inside getPlaces saga")
    console.log(placeInput)
    const response = yield call(getPlaces, placeInput)
    yield put(getPlacesSuccess(places))
  } catch (error) {
    if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
      yield put(getPlacesFail(error.response.data))
    } else {
      yield put(getPlacesFail(error.message))
    }
  }
}

function* getPlacesAPITokenSaga() {
  try {
    const response = yield call(getPlacesAPIToken)
    yield put(getPlacesAPITokenSuccess(response))
  } catch (error) {
    if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
      yield put(getPlacesAPITokenFail(error.response.data))
    } else {
      yield put(getPlacesAPITokenFail(error.message))
    }
  }
}


function* createPayPalOrderSaga() {
  try {
    console.log("inside createPayPalOrderSaga saga ::::::::::::::kkkkkkk=")

    const response = yield call(createPayPalOrder)
    yield put(createPayPalOrderSuccess(response))
  } catch (error) {
    if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
      yield put(createPayPalOrderFail(error.response.data))
    } else {
      yield put(createPayPalOrderFail(error.message))
    }
  }
}
function* approvePayPalOrderSaga({orderId, reportID}) {
  try {
    console.log("inside approvePayPalOrder saga ::::::::::::::jk" + orderId + "reportID==" + reportID )

    const response = yield call(approvePayPalOrder, orderId, reportID)
    console.log("saga response for order approve::::" + response.id)
    yield put(approvePayPalOrderSuccess(response))
  } catch (error) {
    if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
      yield put(approvePayPalOrderFail(error.response.data))
    } else {
      yield put(approvePayPalOrderFail(error.message))
    }
  }
}

function* reportOrderConfirmSaga({ reportID}) {
  try {
    console.log("inside reportOrderConfirmSaga saga ::::::::::::::jk" +  "reportID==" + reportID )

    const response = yield call(reportOrderConfirmatation, reportID)
    console.log("saga response for order approve::::" + response.id)
    yield put(reportOrderConfirmSuccess(response))
  } catch (error) {
    if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
      yield put(reportOrderConfirmFail(error.response.data))
    } else {
      yield put(reportOrderConfirmFail(error.message))
    }
  }
}

function* clearPlacesSaga() {
  yield put(clearPlaces())
}

function* setPlaceKeywordSaga({ placeKeyword }) {
  try {
    yield put(setPlaceKeyword(placeKeyword))
  } catch (error) {
    yield put(clearPlaceKeyword())
  }
}

function* clearPlaceKeywordSaga() {
  yield put(clearPlaceKeyword())
}

function* projectsSaga() {
  //yield takeEvery(GET_BIRTH_CHART_PDF, fetchBirthChartPDF)
  yield takeEvery(GET_BIRTH_CHART, fetchBirthChart)
  yield takeEvery(POST_BIRTH_DETAILS_INPUT, postBirthDetailsInputSaga)
  yield takeEvery(GET_BIRTH_CHART_LIST, fetchBirthChartList)
  yield takeLatest(GET_PLACES, getPlacesSaga)
  yield takeLatest(CLEAR_PLACES, clearPlacesSaga)
  yield takeLatest(SET_PLACE_KEYWORD, setPlaceKeywordSaga)
  yield takeLatest(CLEAR_PLACE_KEYWORD, clearPlaceKeywordSaga)
  yield takeLatest(GET_PLACES_API_TOKEN, getPlacesAPITokenSaga)
  yield takeLatest(CREATE_PAYPAL_ORDER, createPayPalOrderSaga)
  yield takeLatest(APPROVE_PAYPAL_ORDER, approvePayPalOrderSaga)
  yield takeLatest(REPORT_ORDER_CONFIRMATION, reportOrderConfirmSaga)

  
}

export default projectsSaga
